/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  MyCertifiedPlant,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

const build = (_query: DocumentNode, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }{
    getMyPartialCertifiedPlants{
      ...mycertifiedplant
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetMyPartialCertifiedPlantsQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment mycertifiedplant on MyCertifiedPlant { ... }
   */
  async execute(_query: DocumentNode, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getMyPartialCertifiedPlants: Partial<MyCertifiedPlant>[] }>({ query: build(_query), fetchPolicy });
  }
}
